import { useCallback } from 'react';
import { useAnalytics } from '@/shared/features/analytics/presentation/hooks/useAnalytics';
import {
  NAVIGATION_BAR_HOVERED,
  navigationBarHoveredEventProperties,
} from '@/shared/features/analytics/utils/navigationBarHovered';

/** Desktop navbar: fires when pointer enters a main menu item (not dropdown content). */
export function useTrackNavigationBarHovered() {
  const { analytics, isInitialized } = useAnalytics();

  return useCallback(
    (menuName: string) => {
      if (!analytics || !isInitialized) return;
      const name = menuName.trim();
      if (!name) return;
      try {
        analytics.trackEvent(NAVIGATION_BAR_HOVERED, navigationBarHoveredEventProperties(name));
      } catch (err) {
        console.error('Error tracking Navigation Bar Hovered:', err);
      }
    },
    [analytics, isInitialized],
  );
}
